'use strict';

export default {
  formConfirmPage: {
    successMessage: 'Votre formulaire "{formName}" a bien été envoyé',
  },
};
